// extracted by mini-css-extract-plugin
export var errorIcon = "_lv-1";
export var nameLogo = "_lv-0";